import { createClient as createContentfulClient } from 'contentful'

export const getContentfulClient = () =>
    createContentfulClient({
        space: process.env.REACT_APP_CONTENTFUL_SPACE || 'n2xqfrl4jzdr',
        accessToken:
            process.env.REACT_APP_CONTENTFUL_ACCESS_TOKEN ||
            'Wg6guNu8C87uiPVuf0uv64b2zoUJ2aH9gvVvDpAYe1s',
    })
